/**
 * ダウンロード処理
 * @returns {{downloadPng: downloadPng}}
 */
export const useDownload = () => {
  /**
   * pngファイルのダウンロード
   * base64の文字列からpngファイルとしてダウンロードする
   * @param base64
   * @param filename
   */
  const downloadPng = (base64, filename) => {
    const a = document.createElement('a');
    a.href = `data:image/png;base64,${base64}`;
    a.download = filename;
    a.click();
  };
  return {
    downloadPng,
  };
};
